import type { Messages } from './en';

export const fr: Messages = {
  'nav.clientHub': 'Portail Client',
  'nav.menu': 'Menu',
  'nav.home': 'Accueil',
  'nav.products': 'Produits',
  'nav.liveCasino': 'Casino live',
  'nav.slots': 'Slots',
  'nav.tableGames': 'Jeux de table',
  'nav.library': 'Bibliothèque',
  'nav.roadmap': 'Feuille de route',
  'nav.assets': 'Ressources',
  'nav.guidelines': 'Directives',
  'nav.account': 'Compte',
  'nav.signOut': 'Se déconnecter',
  'nav.categoriesAria': 'Catégories de jeux',
  'nav.sectionsAria': 'Sections principales',
  'nav.brandAria': 'RichyPlay Portail Client',
  'nav.comingSoon': 'Bientôt disponible',
  'nav.soon': 'Bientôt',

  'lang.label': 'Langue',
  'lang.select': 'Choisir la langue',

  'category.live': 'En direct',
  'category.slot': 'Machines à sous',
  'category.instant': 'Instantané',
  'category.table': 'Table',

  'status.planned': 'Planifié',
  'status.in_progress': 'En cours',
  'status.shipped': 'Livré',
  'status.available': 'Disponible',
  'status.coming_soon': 'Bientôt disponible',
  'status.maintenance': 'Maintenance',

  'common.error': 'Une erreur est survenue',
  'common.checkingSession': 'Vérification de la session…',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.none': 'Aucun',
  'common.active': 'Actif',
  'common.inactive': 'Inactif',

  'home.eyebrow': 'Portail opérateur',
  'home.title': 'Portail Client',
  'home.lead':
    'Explorez le portefeuille RichyPlay — lancez des démos, suivez la feuille de route et téléchargez les ressources de marque depuis un seul espace de travail.',
  'home.enterLibrary': 'Ouvrir la bibliothèque',
  'home.viewRoadmap': 'Voir la feuille de route',
  'home.browse': 'Parcourir par catégorie',
  'home.openLibrary': 'Ouvrir la bibliothèque',

  'library.eyebrow': 'Bibliothèque de jeux',
  'library.title': 'Portefeuille',
  'library.liveTitle': 'Portefeuille casino live',
  'library.slotTitle': 'Portefeuille slots',
  'library.liveLead': 'Choisissez un produit live. Blackjack et Roulette sont disponibles ; le reste arrive bientôt.',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.lead':
    'Recherchez et filtrez le catalogue RichyPlay. Lancez les démos dans un nouvel onglet.',
  'library.search': 'Rechercher des jeux…',
  'library.statusFilterAria': 'Filtrer par statut',
  'library.statusAll': 'Tous les statuts',
  'library.loading': 'Chargement des jeux…',
  'library.unavailableTitle': 'Bibliothèque indisponible',
  'library.unavailableMessage':
    'Impossible de charger la bibliothèque de jeux. Le catalogue est peut-être indisponible.',
  'library.apiFailedMessage':
    'Nous n’avons pas pu joindre l’API du catalogue. Réessayez plus tard ou contactez le support.',
  'library.emptyTitle': 'Aucun jeu trouvé',
  'library.emptyMessage': 'Essayez une autre recherche ou un autre filtre de catégorie.',
  'library.viewGame': 'Voir le jeu',

  'game.loading': 'Chargement du jeu…',
  'game.notFound': 'Jeu introuvable.',
  'game.back': 'Retour',
  'game.breadcrumbAria': 'Fil d’Ariane',
  'game.liveCasino': 'Casino en direct',
  'game.slots': 'Machines à sous',
  'game.demoFrameTitle': 'Démo de {title}',
  'game.startingDemo': 'Démarrage de la session de démo…',
  'game.demoNotStarted': 'La session de démo n’a pas pu être démarrée.',
  'game.demoBadge': 'Mode démo',
  'game.blockedMaintenance': 'Ce jeu est en maintenance.',
  'game.blockedComingSoon': 'Bientôt disponible — la démo n’est pas encore publiée.',
  'game.blockedNoDemo': 'Le catalogue opérateur ne propose pas de version démo pour ce titre.',
  'game.currency': 'Devise',
  'game.language': 'Langue',
  'game.reloadDemo': 'Recharger la démo',
  'game.startDemo': 'Lancer la démo',
  'game.openNewTab': 'Ouvrir dans un nouvel onglet',
  'game.copyLink': 'Copier le lien',
  'game.copied': 'Copié',
  'game.demoFailedTitle': 'Échec du lancement de la démo',
  'game.demoUrlMissing': 'Le serveur n’a pas renvoyé d’URL de lancement.',
  'game.demoFailed': 'Impossible de lancer la démo.',
  'game.highlighted': 'Mis en avant',
  'game.features': 'Fonctionnalités du jeu',
  'game.keyFeatures': 'Points clés',
  'liveTable.title': 'Tables disponibles',
  'liveTable.totalResults': 'Résultats totaux :',
  'liveTable.download': 'Télécharger les données de table',
  'liveTable.gameId': 'ID du jeu',
  'liveTable.tableName': 'Nom de la table',
  'liveTable.minLimit': 'Limite min. de table',
  'liveTable.maxLimit': 'Limite max. de table',
  'liveTable.hours': 'Heures d’ouverture UTC',
  'liveTable.language': 'Langue d’exploitation',
  'liveTable.releaseDate': 'Date de sortie',
  'liveTable.location': 'Emplacement',
  'game.betLevels': 'Niveaux de mise',
  'game.tableRules': 'Règles de la table',
  'game.mathConfig': 'Configuration mathématique',
  'game.resources': 'Ressources',
  'game.relatedAssets': 'Ressources associées',
  'game.releaseRoadmap': 'Feuille de route des sorties',
  'game.integrationGuidelines': 'Directives d’intégration',
  'game.information': 'Informations sur le jeu',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': 'Ordinateur',
  'game.platformTablet': 'Tablette',
  'game.platformMobile': 'Mobile',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': 'La fiche de données du jeu sera bientôt ajoutée.',

  'spec.numericId': 'ID numérique',
  'spec.minBetPerLine': 'Mise minimum par ligne',
  'spec.minTotalBet': 'Mise totale minimum',
  'spec.maxTotalBet': 'Mise totale maximum',
  'spec.maxTotalBetAnte': 'Mise totale max. avec Ante',
  'spec.reels': 'Rouleaux',
  'spec.rows': 'Rangées',
  'spec.payType': 'Type de gain',
  'spec.payLinesValue': '{count} lignes',
  'spec.symbolPays': 'Gains par symbole',
  'spec.betMultiplier': 'Multiplicateur de mise',
  'spec.maxMultiplierWin': 'Gain max. du multiplicateur',
  'spec.maxExposure': 'Exposition maximale',
  'spec.bonusBuyX': 'Achat de bonus X',
  'spec.anteBetX': 'Mise Ante X',
  'spec.rtps': 'RTP',
  'spec.hitFrequency': 'Fréquence de gain',
  'spec.oneIn': '1 sur {value}',
  'spec.hasReplay': 'Replay',
  'spec.hasBuySpins': 'Achat de tours',
  'spec.hasInstantBonus': 'Bonus instantané',
  'spec.hasHyperplay': 'Hyperplay',
  'spec.hasAnteBet': 'Mise Ante',
  'spec.releaseDate': 'Date de sortie',
  'spec.symbol': 'Symbole du jeu',
  'spec.referenceId': 'ID de référence',
  'spec.provider': 'Fournisseur',
  'spec.product': 'Produit',
  'spec.gameType': 'Type de jeu',
  'spec.category': 'Catégorie',
  'spec.theme': 'Thème',
  'spec.technology': 'Technologie',
  'spec.rtp': 'RTP',
  'spec.volatility': 'Volatilité',
  'spec.maxWin': 'Gain maximum',
  'spec.paylines': 'Lignes de paiement',
  'spec.grid': 'Grille',
  'spec.bonusFrequency': 'Fréquence des bonus',
  'spec.bonusFrequencyValue': '1 sur {value}',
  'spec.jackpot': 'Jackpot',
  'spec.betRange': 'Plage de mise',
  'spec.defaultBet': 'Mise par défaut',
  'spec.currency': 'Devise',
  'spec.languages': 'Langues',
  'spec.demoAvailable': 'Démo disponible',
  'spec.tournaments': 'Tournois',
  'spec.highlighted': 'Mis en avant',
  'spec.status': 'Statut',
  'spec.version': 'Version',
  'spec.lastUpdated': 'Dernière mise à jour',

  'roadmap.eyebrow': 'Feuille de route produit',
  'roadmap.title': 'À venir',
  'roadmap.lead': 'Suivez les prochaines sorties et les titres livrés par catégorie.',
  'roadmap.bannerAria': 'Prochaines sorties',
  'roadmap.soonTitle': 'Bientôt disponible',
  'roadmap.loading': 'Chargement de la feuille de route…',
  'roadmap.error': 'Impossible de charger les éléments de la feuille de route.',
  'roadmap.emptyTitle': 'Aucun élément',
  'roadmap.emptyMessage': 'Aucune entrée publiée pour cette catégorie pour le moment.',
  'roadmap.itemCount': '{count} éléments',
  'roadmap.target': 'Objectif : {date}',
  'roadmap.viewInLibrary': 'Voir dans la bibliothèque',

  'upcoming.title': 'Prochaines sorties',
  'upcoming.playDemo': 'Jouer la démo',
  'upcoming.prev': 'Sorties précédentes',
  'upcoming.next': 'Sorties suivantes',

  'assets.eyebrow': 'Ressources de marque',
  'assets.title': 'Packs de ressources',
  'assets.lead':
    'Téléchargez les logos, visuels clés et supports marketing. Consultez {link} pour les règles d’utilisation.',
  'assets.leadLink': 'les directives sur les ressources',
  'assets.loading': 'Chargement des ressources…',
  'assets.error': 'Impossible de charger les packs de ressources.',
  'assets.downloadFailed': 'Échec du téléchargement.',
  'assets.emptyTitle': 'Aucune ressource',
  'assets.emptyForGame': 'Aucun pack de ressources n’est lié à ce jeu.',
  'assets.emptyGeneral': 'Les packs de ressources apparaîtront ici une fois publiés.',
  'assets.pack': 'Pack',
  'assets.updated': 'Mis à jour le {date}',
  'assets.download': 'Télécharger',
  'assets.search': 'Rechercher par nom de jeu…',
  'assets.searchEmpty': 'Aucun jeu ne correspond à ce nom.',

  'guidelines.eyebrow': 'Documentation',
  'guidelines.title': 'Directives',
  'guidelines.lead':
    'Notes d’intégration, utilisation des ressources et références pour les opérateurs.',
  'guidelines.all': 'Toutes',
  'guidelines.integration': 'Intégration',
  'guidelines.assets': 'Ressources',
  'guidelines.loading': 'Chargement des directives…',
  'guidelines.error': 'Impossible de charger les directives.',
  'guidelines.emptyTitle': 'Aucune directive',
  'guidelines.emptyMessage': 'Les directives publiées apparaîtront ici.',
  'guidelines.index': 'Index',
  'guidelines.navAria': 'Navigation des directives',
  'guidelines.articleLoading': 'Chargement de l’article…',
  'guidelines.notFound': 'Directive introuvable.',
  'guidelines.notFoundShort': 'Introuvable',
  'guidelines.updated': 'Mis à jour le {date}',
  'guidelines.external': 'Le contenu est hébergé en externe.',
  'guidelines.openDocument': 'Ouvrir le document',
  'guidelines.typeGuide': 'Guide',
  'guidelines.typeGuideline': 'Directive',

  'account.eyebrow': 'Votre compte',
  'account.title': 'Profil',
  'account.email': 'E-mail',
  'account.language': 'Langue de l’interface',
  'account.recentActivity': 'Activité récente',
  'account.loadingActivity': 'Chargement de l’activité…',
  'account.activityUnavailable': 'L’activité récente n’est pas disponible pour le moment.',
  'account.noActivity': 'Aucune activité récente enregistrée.',

  'event.login': 'Connexion',
  'event.logout': 'Déconnexion',
  'event.libraryView': 'Bibliothèque consultée',
  'event.gameView': 'Jeu consulté',
  'event.demoLaunch': 'Démo lancée',
  'event.demoLaunchFailed': 'Échec du lancement de la démo',
  'event.assetDownload': 'Ressource téléchargée',
  'event.guidelineView': 'Directive consultée',
  'event.roadmapView': 'Feuille de route consultée',

  'auth.title': 'Portail Client',
  'auth.subtitle': 'Connectez-vous avec vos identifiants opérateur',
  'auth.email': 'E-mail',
  'auth.password': 'Mot de passe',
  'auth.rememberMe': 'Se souvenir de moi',
  'auth.signIn': 'Se connecter',
  'auth.signInFailed': 'Échec de la connexion',
  'auth.signInError': 'Connexion impossible. Vérifiez vos identifiants et réessayez.',
  'auth.forgotPassword': 'Mot de passe oublié ?',
  'auth.inviteOnly': 'Accès sur invitation uniquement. Contactez votre référent RichyPlay.',
  'auth.visitSiteAria': 'Aller sur richyplay.live',

  'footer.navAria': 'Pied de page',
  'footer.tagline': 'Portail opérateurs pour le catalogue de slots et de casino live RichyPlay.',
  'footer.rights': 'Tous droits réservés.',
  'footer.legal':
    'Accès sur invitation pour les opérateurs agréés. Réservé à un usage professionnel.',

  'forgot.eyebrow': 'Réinitialisation du mot de passe',
  'forgot.title': 'Mot de passe oublié',
  'forgot.requestSubtitle':
    'Saisissez votre e-mail et nous enverrons un code de vérification si un compte existe.',
  'forgot.sendCode': 'Envoyer le code',
  'forgot.sendError': 'Impossible d’envoyer le code de réinitialisation.',
  'forgot.confirmSubtitle':
    'Saisissez le code reçu par e-mail et choisissez un nouveau mot de passe.',
  'forgot.code': 'Code de vérification',
  'forgot.newPassword': 'Nouveau mot de passe',
  'forgot.update': 'Mettre à jour le mot de passe',
  'forgot.updateError': 'Impossible de réinitialiser le mot de passe.',
  'forgot.doneSubtitle': 'Votre mot de passe a été mis à jour. Vous pouvez vous connecter.',
  'forgot.backToSignIn': 'Retour à la connexion',
};
